import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateQuestionBankTopicToggle } from '../services/questionBankSubjectService';

export function useQuestionBankTopicToggle(subjectQueryParams = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateQuestionBankTopicToggle,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['questionBankSubjects'],
      });
      queryClient.invalidateQueries({ queryKey: ['questionBankTopics'] });
    },
  });
}
